import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'footer-govsp',
  templateUrl: './footer-govsp.component.html',
  styleUrls: ['./footer-govsp.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class FooterGovSpComponent {
  periodoEleitoral: boolean = environment.periodoEleitoral;
}
